import { Edge } from 'reactflow';
import { CustomNode, Transition } from './nodes';

export function createEdgesFromTransitions(
    transitions: Transition[],
    nodes: CustomNode[]
): Edge[] {
    const edges: Edge[] = [];

    transitions.forEach((transition, index) => {
        const sourceNode = nodes.find(node => formatStateName(node.id) === transition.from);
        const targetNode = nodes.find(node => formatStateName(node.id) === transition.to);

        if (sourceNode && targetNode) {
            // Create a more descriptive label for reroute actions
            let label = transition.event;
            
            // Check if this is a reroute action by looking for REROUTE in the event name
            if (label && label.includes('REROUTE')) {
                // For reroute actions, show the destination node label instead of just the event name
                // @ts-ignore - accessing data.label which exists on our custom nodes
                const targetNodeLabel = targetNode.data?.label || targetNode.id;
                label = `→ ${targetNodeLabel}`;
            }
            
            edges.push({
                id: `edge-${index}`,
                source: sourceNode.id,
                target: targetNode.id,
                sourceHandle: 'bottom',  // Assuming the source handle is at the bottom of the node
                targetHandle: 'top',     // Assuming the target handle is at the top of the node
                label: label,
                type: 'smoothstep', // You can change this to other edge types if needed
                animated: true,
                style: { stroke: '#888' },
            });
        }
    });

    return edges;
}

function formatStateName(name: string): string {
    return name.toUpperCase().replace(/\s+/g, '_');
}